import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAccordion from '../FilterAccordion';

const styles = {
  accordionSummaryTitle: {
    bgcolor: 'secondary.main',
    color: 'white',
    height: '50px',
    minHeight: '50px',
    borderRadius: '4px',
    fontWeight: '600',
    fontSize: '16px',
    '&.Mui-expanded': { margin: '0 !important', minHeight: 'unset !important' },
  },
  accordionDetails: {
    py: 0,
    px: 1,
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
  },
};

const Filters = props => {
  const { facets, setData, setError, setLoading, setSelectedFilters } = props;

  return (
    <Box my={5}>
      {!!facets?.length && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="filters-content"
            id="filters-header"
            sx={styles.accordionSummaryTitle}
          >
            Filters
          </AccordionSummary>
          <AccordionDetails sx={styles.accordionDetails}>
            {facets.map(facet => (
              <FilterAccordion
                key={facet.id}
                facet={facet}
                setSelectedFilters={setSelectedFilters}
                setData={setData}
                setError={setError}
                setLoading={setLoading}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};

export default Filters;
